// extracted by mini-css-extract-plugin
module.exports = {"inspection-report":"inspection-report-pdf_inspection-report___fSZg"};